import React from 'react';
import { Outlet } from 'react-router';

import LandingPageHeader from '../components/header/LandingPageHeader';
import '../index.scss';

/**
 * The auth layout component that wraps the application with a header and footer
 * @returns {React.JSX.Element}
 */
export default function MinimalLayout() {
  return (
    <>
      <LandingPageHeader />
      <div className="minimal-layout-content">
        <main>
          <Outlet />
        </main>
      </div>
    </>
  );
}
